import { StrengthKey } from '../types';

/* 10 Strengths */
export const strengthName: Record<StrengthKey, string> = {
  AIDIR: 'AI指示力',
  TOOLC: 'ツール活用力',
  IDEAS: 'アイデア創出力',
  EMBRI: '共感・ブリッジ力',
  FLOWM: 'フロー管理力',
  AMBIG: '曖昧さ許容力',
  MICRO: 'マイクロタスク力',
  FOCUS: '集中持続力',
  ANTIF: '先行検証力',
  DATAR: 'データ分析力'
};

export const strengthTips: Record<StrengthKey, string> = {
  AIDIR: 'AIに渡す指示は具体的で明確に。目的とコンテキストを含め、段階的に詳細化していくことで、より質の高い結果が得られます。',
  TOOLC: '適切なツールの選択と組み合わせが効率を大きく左右します。新しいツールへの適応力を磨き、ワークフローを最適化しましょう。',
  IDEAS: '異なる分野の知識を組み合わせ、新しい視点を見出すことが重要です。定期的なブレインストーミングで創造力を養いましょう。',
  EMBRI: 'チーム間の橋渡し役として、各メンバーの視点や懸念を理解し、建設的な対話を促進することで、より良い協働が実現できます。',
  FLOWM: 'タスクの優先順位付けと進捗管理が鍵です。チームの状況を把握し、ボトルネックを早期に特定・解消することで、スムーズな進行を実現できます。',
  AMBIG: '不確実な状況でも冷静に判断し、段階的に明確化していく姿勢が重要です。完璧を求めすぎず、反復的な改善を心がけましょう。',
  MICRO: '大きなタスクを適切なサイズに分割し、具体的なアクションに落とし込むことで、効率的な実行が可能になります。',
  FOCUS: '集中を妨げる要因を特定し、環境を整えることが重要です。適切な休憩を取り入れ、持続可能な作業リズムを作りましょう。',
  ANTIF: '潜在的な問題を早期に発見し、対策を講じることで、後々の手戻りを防ぐことができます。小規模な検証を重ねていきましょう。',
  DATAR: 'データに基づく意思決定の重要性を理解し、適切な分析手法を選択することで、より確実な判断が可能になります。'
};
